/**
 * Sensors API Detector
 */

export interface SensorsResult {
  accelerometer: boolean;
  gyroscope: boolean;
  magnetometer: boolean;
}

export async function detectSensorAPIs(): Promise<SensorsResult> {
  try {
    const result: SensorsResult = {
      accelerometer: false,
      gyroscope: false,
      magnetometer: false,
    };

    // Check for Accelerometer
    if ('Accelerometer' in window) {
      result.accelerometer = true;
    }

    // Check for Gyroscope
    if ('Gyroscope' in window) {
      result.gyroscope = true;
    }

    // Check for Magnetometer
    if ('Magnetometer' in window) {
      result.magnetometer = true;
    }

    return result;
  } catch (error) {
    return {
      accelerometer: false,
      gyroscope: false,
      magnetometer: false,
    };
  }
}
